import axios, { AxiosResponse } from 'axios'

import gql from '@js/api/utils/gql'
import { env } from '@js/utils/env'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { CustomerLicense } from '@js/api/types/customer/CustomerLicense'

interface DeleteCustomerLicensePayload {
  customerId: number
  licenseId: number
}

interface DeleteCustomerLicenseResponse {
  data: {
    wceiDeleteCustomerLicense: CustomerLicense
  }
  errors?: [{ message: string }]
}

export const deleteCustomerLicenseMutation = gql`
  mutation wceiDeleteCustomerLicense($licenseId: Int!) {
    wceiDeleteCustomerLicense(input: { 
      license_id: $licenseId
    }) {
      license_id
      customer_id
      license_type
      license_number
      license_state
    }
  }
 `

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const deleteCustomerLicense = async (payload: DeleteCustomerLicensePayload): Promise<CustomerLicense> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<DeleteCustomerLicenseResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: deleteCustomerLicenseMutation,
      variables: payload,
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  return data.data.wceiDeleteCustomerLicense
}
